import React from 'react'

import * as style from './TrustedSection.module.css'

type PartnerType = {
  name: string
  logo: {
    publicURL: string
  }
  link: string
}

type TrustedSectionPropType = {
  title: string
  partners: PartnerType[]
}

export default function TrustedSection({
  title,
  partners
}: TrustedSectionPropType) {
  return (
    <div className={style.root}>
      <div className={style.title}>{title}</div>
      <div className={style.partners}>
        {partners.map((partner: PartnerType) => (
          <div className={style.partner} key={partner.name}>
            <a href={partner.link} target="_blank" rel="noreferrer">
              <img
                src={partner.logo.publicURL}
                alt={partner.name}
                className={style.logo}
              />
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}
